<div (click)="showTasks()" style="cursor: pointer; width: 48px;"
     class="tasks ps-3 pe-3 ms-2 me-2">
    <div class="tasks-icon"
         [ngClass]="taskCount > 0 ? 'task-light' : 'task-dark'">
        <i *ngIf="taskCount > 0" class="badge">{{taskCount}}</i>
        <i class="fas fa-list-check fa-xl"></i>
    </div>
</div>

<div class="task-details card card-body bg-light" [ngClass]="{ 'fade-in': showingTasks === true, 'fade-out': showingTasks === false }">

    <div class=" d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom border-body">
        <div style="font-size: 18px; font-weight: 700; ">Tasks</div>
        <div class="d-flex align-items-center" style="gap: 8px;">
            <button class="btn btn-task-add btn-sm" (click)="addTask()">
                <i class="far fa-plus me-1" style="font-size: 12px;"></i> Add Task
            </button>
        </div>
    </div>

    <div class="d-flex flex-fill text-body" style="min-width: 600px; max-width: 800px;">
        <task-list (hideTaskWindow)="hideTaskWindow()"></task-list>
    </div>
</div>

<task-edit-dialog #taskEditDialogRef></task-edit-dialog>
